export const getFormStructure = ({
  motivoOptions = [],
  tagOptions = [],
  disableTagsField = false,
  isReadOnly = false,
} = {}) => [
  [
    {
      name: 'motivoId',
      label: 'Motivo',
      placeholder: 'Selecione o motivo',
      component: 'SearchSelect',
      isMulti: false,
      options: motivoOptions,
      disabled: isReadOnly,
      colProps: { md: 6 },
      required: true,
    },
    {
      name: 'desejaAcompanhar',
      label: 'Deseja acompanhar',
      placeholder: 'Selecione',
      component: 'SearchSelect',
      isMulti: false,
      options: [
        { value: 'true', label: 'Sim' },
        { value: 'false', label: 'Nao' },
      ],
      disabled: isReadOnly,
      colProps: { md: 6 },
    },
  ],
  [
    {
      name: 'relatadoLiderStatus',
      label: 'Relatado lider status',
      placeholder: 'Selecione',
      component: 'SearchSelect',
      isMulti: false,
      options: [
        { value: '1', label: 'Sim' },
        { value: '2', label: 'Nao' },
        { value: '3', label: 'Prefiro nao informar' },
        { value: '4', label: 'Nao sei quem e' },
      ],
      disabled: isReadOnly,
      colProps: { md: 6 },
    },
    {
      name: 'statusAtual',
      label: 'Status atual',
      placeholder: 'Selecione',
      component: 'SearchSelect',
      isMulti: false,
      options: [
        { value: '1', label: 'Em aberto' },
        { value: '2', label: 'Visto' },
        { value: '3', label: 'Em analise' },
        { value: '4', label: 'Em comite' },
        { value: '5', label: 'Finalizado' },
      ],
      disabled: isReadOnly,
      colProps: { md: 6 },
    },
  ],
  [
    isReadOnly
      ? {
          name: 'tagsDisplay',
          label: 'Tags',
          placeholder: '-',
          component: 'FormField',
          type: 'text',
          readOnly: true,
          colProps: { md: 12 },
        }
      : {
          name: 'tags',
          label: 'Tags',
          placeholder: disableTagsField
            ? 'Tags disponiveis apenas na criacao'
            : 'Selecione as tags',
          component: 'SearchSelect',
          isMulti: true,
          showSelectAll: true,
          options: tagOptions,
          disabled: disableTagsField,
          colProps: { md: 12 },
        },
  ],
  [
    {
      name: 'relato',
      label: 'Relato',
      placeholder: 'Descreva o relato da ouvidoria',
      component: 'Textarea',
      type: 'textarea',
      rows: 5,
      colProps: { md: 12 },
      required: true,
      maxLength: 3000,
      disabled: isReadOnly,
    },
  ],
  [
    {
      name: 'protocolo',
      label: 'Protocolo',
      placeholder: 'Gerado automaticamente',
      component: 'FormField',
      type: 'text',
      readOnly: true,
      colProps: { md: 6 },
    },
    {
      name: 'telefone',
      label: 'Telefone',
      placeholder: '-',
      component: 'FormField',
      type: 'text',
      readOnly: true,
      colProps: { md: 6 },
    },
  ],
  [
    {
      name: 'enderecoMotivo',
      label: 'Endereco do motivo',
      placeholder: '-',
      component: 'FormField',
      type: 'text',
      readOnly: true,
      colProps: { md: 6 },
    },
    {
      name: 'dataHoraMotivo',
      label: 'Data/hora do motivo',
      placeholder: '-',
      component: 'FormField',
      type: 'text',
      readOnly: true,
      colProps: { md: 6 },
    },
  ],
  [
    {
      name: 'dataCriacao',
      label: 'Data de criacao',
      placeholder: '-',
      component: 'FormField',
      type: 'text',
      readOnly: true,
      colProps: { md: 6 },
    },
    {
      name: 'filialNome',
      label: 'Filial',
      placeholder: '-',
      component: 'FormField',
      type: 'text',
      readOnly: true,
      colProps: { md: 6 },
    },
  ],
];

export const formSections = initialValues => [
  {
    title: `Detalhes da Ouvidoria ${initialValues.protocolo ? `- ${initialValues.protocolo}` : ''}`,
    rows: [0, 1, 2, 3, 4, 5, 6],
  },
];

export const validateForm = values => {
  const errors = {};

  if (!values?.motivoId) {
    errors.motivoId = 'Motivo e obrigatorio';
  }

  if (!values?.relato || String(values.relato).trim().length === 0) {
    errors.relato = 'Relato e obrigatorio';
  }

  return errors;
};
